import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/products/${product._id}`}
      className="group block bg-slate-100 rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1 relative focus:outline-none focus:ring-2 focus:ring-green-500"
    >
      {/* Image */}
      <div className="relative aspect-[4/3] sm:aspect-[5/4] overflow-hidden rounded-t-xl">
        <img
          src={product.coverImage}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />

        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300" />
      </div>

      {/* Content */}
      <div className="p-4 sm:p-5">
        <span className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider">
          {product.category}
        </span>
        <h3 className="mt-1 mb-2 sm:mb-3 text-sm sm:text-lg font-semibold text-gray-900 transition-colors group-hover:text-green-600">
          {product.name}
        </h3>
        <span className="inline-flex items-center text-xs sm:text-sm font-medium text-green-600 gap-1 group-hover:gap-2 transition-all">
          View Details
          <ArrowRight
            size={14}
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </span>
      </div>

      {/* Featured Badge */}
      {product.starred && (
        <span className="absolute top-3 left-3 sm:top-4 sm:left-4 z-20 bg-yellow-400 text-white text-[10px] sm:text-xs px-2 sm:px-3 py-1 rounded-full shadow-md animate-pulse">
          ★ Featured
        </span>
      )}
    </Link>
  );
};

export default ProductCard;